import EditOriginalConfirmationModal from './EditOriginalConfirmationModal';

export default EditOriginalConfirmationModal;
